import React from "react";
import { MenuItem } from "@shared/interfaces";

import SidebarItem from "../SidebarItem/SidebarItem";

import "./index.scss";

interface SidebarItemsProps {
  items: MenuItem[];
}

const SidebarItems = (props: SidebarItemsProps) => {
  const { items } = props;
  return (
    <div className="sidebar-items">
      {items.map((item) => (
        <SidebarItem key={item.name} item={item} />
      ))}
    </div>
  );
};

export default SidebarItems;
